import { render, staticRenderFns } from "./auction-work-classifications.vue?vue&type=template&id=9b6a85d2&scoped=true&"
import script from "./auction-work-classifications.vue?vue&type=script&lang=js&"
export * from "./auction-work-classifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a85d2",
  null
  
)

export default component.exports